// extracted by mini-css-extract-plugin
module.exports = {"device":"_2ppsBVe_bHOCtBrCghXzPG","lastSeenTime":"SqcIrPndIyfWDM-KbW5yi","desktop":"_2XVwr8DfjE6CTpqn6zMoRG","mobile":"_1XzFN9F9hu2j_khaiFEiRx","tablet":"nRtjBW4Xk9upzx-wE2kMp"};